import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledArrowSortDown: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-sort-down"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-sort-down icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M10.0025 15.2902L12.6468 12.6458C12.8421 12.4506 13.1587 12.4506 13.3539 12.6458C13.5492 12.8411 13.5492 13.1577 13.3539 13.3529L9.8856 16.8213C9.79388 16.9305 9.65628 17 9.50245 17L9.50079 17C9.4221 17 9.34341 16.9816 9.27177 16.9447C9.22664 16.9215 9.1843 16.891 9.1465 16.8533L9.13652 16.843L5.64645 13.3529C5.45118 13.1577 5.45118 12.8411 5.64645 12.6458C5.84171 12.4505 6.15829 12.4505 6.35355 12.6458L9.00245 15.2947L9.00245 3.5C9.00245 3.22386 9.22631 3 9.50245 3C9.77859 3 10.0025 3.22386 10.0025 3.5L10.0025 15.2902Z" />
      </svg>
    </span>
  );
};

export { FilledArrowSortDown };
